import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import SectionTitle from "../../components/SectionTitle";
import SingleProject from "../../components/Project";

import shapeImg1 from "../../assets/img/project/pro-shape-1.png";
import shapeImg2 from "../../assets/img/project/pro-shape-2.png";
import shapeImg3 from "../../assets/img/project/pro-shape-4.png";
import shapeImg4 from "../../assets/img/project/pro-shape-5.png";

// Import project images - organized by project subfolders
import Res1 from "../../assets/img/project/erestaurant/Res1.png";
import Res2 from "../../assets/img/project/erestaurant/Res2.png";
import Res3 from "../../assets/img/project/erestaurant/Res3.png";
import Res4 from "../../assets/img/project/erestaurant/Res4.png";
import Res5 from "../../assets/img/project/erestaurant/Res5.png";
import Stock1 from "../../assets/img/project/estock/Stock1.png";
import Stock2 from "../../assets/img/project/estock/Stock2.png";
import Stock3 from "../../assets/img/project/estock/Stock3.png";
import Stock4 from "../../assets/img/project/estock/Stock4.png";
import Stock5 from "../../assets/img/project/estock/Stock5.png";
import CRM1 from "../../assets/img/project/crm/CRM1.png";
import CRM2 from "../../assets/img/project/crm/CRM2.png";
import CRM3 from "../../assets/img/project/crm/CRM3.png";
import stocktally1 from "../../assets/img/project/stocktally/StockTally1.png";
import stocktally2 from "../../assets/img/project/stocktally/StockTally2.png";
import stocktally3 from "../../assets/img/project/stocktally/StockTally3.png";
import stocktally4 from "../../assets/img/project/stocktally/StockTally4.png";
import stocktally5 from "../../assets/img/project/stocktally/StockTally5.png";
import Asset1 from "../../assets/img/project/asset-management/Asset1.png";
import Asset2 from "../../assets/img/project/asset-management/Asset2.png";
import Asset3 from "../../assets/img/project/asset-management/Asset3.png";
import Asset4 from "../../assets/img/project/asset-management/Asset4.png";
import Asset5 from "../../assets/img/project/asset-management/Asset5.png";
import Atten1 from "../../assets/img/project/attendance-management/Atten1.png";
import Atten2 from "../../assets/img/project/attendance-management/Atten2.png";
import Atten3 from "../../assets/img/project/attendance-management/Atten3.png";
import Atten4 from "../../assets/img/project/attendance-management/Atten4.png";
import Atten5 from "../../assets/img/project/attendance-management/Atten5.png";
import estockMobile1 from "../../assets/img/project/estock-mobile/estockMobile1.png";
import estockMobile2 from "../../assets/img/project/estock-mobile/estockMobile2.png";
import estockMobile3 from "../../assets/img/project/estock-mobile/estockMobile3.png";
import estockMobile4 from "../../assets/img/project/estock-mobile/estockMobile4.png";
import estockMobile5 from "../../assets/img/project/estock-mobile/estockMobile5.png";
import AttenAdmin1 from "../../assets/img/project/attendance-admin/AttenAdmin1.png";
import AttenAdmin2 from "../../assets/img/project/attendance-admin/AttenAdmin2.png";
import AttenAdmin3 from "../../assets/img/project/attendance-admin/AttenAdmin3.png";
import AttenAdmin4 from "../../assets/img/project/attendance-admin/AttenAdmin4.png";
import AttenAdmin5 from "../../assets/img/project/attendance-admin/AttenAdmin5.png";
import AttenEmp1 from "../../assets/img/project/attendance-employee/AttenEmp1.png";
import AttenEmp2 from "../../assets/img/project/attendance-employee/AttenEmp2.png";
import AttenEmp3 from "../../assets/img/project/attendance-employee/AttenEmp3.png";
import AttenEmp4 from "../../assets/img/project/attendance-employee/AttenEmp4.png";
import AttenEmp5 from "../../assets/img/project/attendance-employee/AttenEmp5.png";
import QM1 from "../../assets/img/project/quarterManagement/QM1.png";
import QM2 from "../../assets/img/project/quarterManagement/QM2.png";
import QM3 from "../../assets/img/project/quarterManagement/QM3.png";
import QM4 from "../../assets/img/project/quarterManagement/QM4.png";
import QM5 from "../../assets/img/project/quarterManagement/QM5.png";

// Project data for homepage section - all projects
const projectsData = [
  {
    id: "erestaurant",
    title: "eRestaurant POS System",
    category: "Web Applications",
    platform: "Web",
    mainImage: Res1,
    images: [Res1, Res2, Res3, Res4, Res5],
  },
  {
    id: "estock",
    title: "eStock Inventory Management",
    category: "Web Applications",
    platform: "Web",
    mainImage: Stock1,
    images: [Stock1, Stock2, Stock3, Stock4, Stock5],
  },
  {
    id: "asset-management",
    title: "Asset Management System",
    category: "Web Applications",
    platform: "Web",
    mainImage: Asset1,
    images: [Asset1, Asset2, Asset3, Asset4, Asset5],
  },
  {
    id: "stocktally",
    title: "StockTally Mobile App",
    category: "Mobile Apps",
    platform: "Mobile",
    mainImage: stocktally1,
    images: [stocktally1, stocktally2, stocktally3, stocktally4, stocktally5],
  },
  {
    id: "crm-system",
    title: "Customer Relationship Manager",
    category: "Web Applications",
    platform: "Web",
    mainImage: CRM1,
    images: [CRM1, CRM2, CRM3],
  },
  {
    id: "attendance-management",
    title: "Attendance Management System",
    category: "Web Applications",
    platform: "Web",
    mainImage: Atten1,
    images: [Atten1, Atten2, Atten3, Atten4, Atten5],
  },
  {
    id: "estock-mobile",
    title: "eStock Mobile App",
    category: "Mobile Apps",
    platform: "Mobile",
    mainImage: estockMobile1,
    images: [estockMobile1, estockMobile2, estockMobile3, estockMobile4, estockMobile5],
  },
  {
    id: "attendance-admin",
    title: "Attendance Admin Mobile App",
    category: "Mobile Apps",
    platform: "Mobile",
    mainImage: AttenAdmin1,
    images: [AttenAdmin1, AttenAdmin2, AttenAdmin3, AttenAdmin4, AttenAdmin5],
  },
  {
    id: "attendance-employee",
    title: "Attendance Employee App",
    category: "Mobile Apps",
    platform: "Mobile",
    mainImage: AttenEmp1,
    images: [AttenEmp1, AttenEmp2, AttenEmp3, AttenEmp4, AttenEmp5],
  },
  {
    id: "quarter-management",
    title: "Quarter Management System",
    category: "Web Applications",
    platform: "Web",
    mainImage: QM1,
    images: [QM1, QM2, QM3, QM4, QM5],
  },
];

// Helper function to get projects by category
const getProjectsByCategory = (category) => {
  if (category === "All Projects") return projectsData;
  return projectsData.filter((project) => project.category === category);
};

const Project = () => {
  let tab1 = "All Projects",
    tab2 = "Mobile Apps",
    tab3 = "Web Applications",
    tab4 = "Business Systems";
  const tabStyle =
    "nav justify-content-center project-2__button-box masonary-menu";

  const [open, setOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);

  // Handler for image gallery
  const handleClick = (images) => {
    setLightboxImages(images.map((img) => ({ src: img })));
    setOpen(true);
  };

  // Function to render projects for each tab
  const renderProjects = (category) => {
    const projects = getProjectsByCategory(category);

    return (
      <TabPanel className="row">
        {projects.map((project, index) => {
          const isMobile = project.platform === "Mobile";
          return (
            <div
              key={project.id}
              className="col-12 col-md-6 mb-4 wow animate__fadeInUp"
              data-wow-duration={`${0.6 + index * 0.3}s`}
            >
              <SingleProject
                Image={project.mainImage}
                Title={project.title}
                categoryOne={project.platform}
                categoryTwo={project.category}
                onClickHandler={() => handleClick(project.images)}
                isMobileApp={isMobile}
              />
            </div>
          );
        })}
      </TabPanel>
    );
  };

  return (
    <>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={lightboxImages}
      />

      <div className="project-2__area project-2__plr project-2__space p-relative fix">
        <div className="project-2__shape-1 d-none d-lg-block">
          <img src={shapeImg1} alt="" />
        </div>
        <div className="project-2__shape-2 d-none d-lg-block">
          <img src={shapeImg2} alt="" />
        </div>
        <div className="project-2__shape-3 d-none d-lg-block">
          <img src={shapeImg3} alt="" />
        </div>
        <div className="project-2__shape-4 d-none d-lg-block">
          <img src={shapeImg4} alt="" />
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <SectionTitle
                sectionClass="project-2__section-box text-center pb-30 section-title-fixed-width"
                subTitle="My Portfolio"
                Title="Business Solutions I've Built for Real Clients"
              />
            </div>
          </div>
          <Tabs>
            <div className="row">
              <div
                className="col-xl-12 wow animate__fadeInUp"
                data-wow-duration="1.1s"
              >
                <TabList className={tabStyle}>
                  <Tab>
                    <button>{tab1}</button>
                  </Tab>
                  <Tab>
                    <button>{tab2}</button>
                  </Tab>
                  <Tab>
                    <button>{tab3}</button>
                  </Tab>
                  <Tab>
                    <button>{tab4}</button>
                  </Tab>
                </TabList>
              </div>
            </div>

            {/* All Projects Tab */}
            {renderProjects("All Projects")}

            {/* Mobile Apps Tab */}
            {renderProjects("Mobile Apps")}

            {/* Web Applications Tab */}
            {renderProjects("Web Applications")}

            {/* Business Systems Tab (same as Web Applications for now) */}
            {renderProjects("Web Applications")}
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default Project;
